import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-selector-dropdown-values',
  templateUrl: './selector-dropdown-values.component.html',
  styleUrls: ['./selector-dropdown-values.component.scss']
})
export class SelectorDropdownValuesComponent {
  @Input() valueControl!: UntypedFormArray;  // Pass FormArray from parent

  @Output() valueAdded = new EventEmitter<void>();
  @Output() valueRemoved = new EventEmitter<number>();
  @Output() valuesReordered = new EventEmitter<any>();

  valueFormGroup = (value: any): UntypedFormGroup => value as UntypedFormGroup;

}
